/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Retainer_Execute_Output7Inputs */

const en_svc_retainer_execute_output7 = /** @type {(inputs: Svc_Retainer_Execute_Output7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monthly changelog`)
};

const ar_svc_retainer_execute_output7 = /** @type {(inputs: Svc_Retainer_Execute_Output7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سجل التغييرات الشهري`)
};

const bn_svc_retainer_execute_output7 = /** @type {(inputs: Svc_Retainer_Execute_Output7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`মাসিক পরিবর্তন লগ`)
};

const de_svc_retainer_execute_output7 = /** @type {(inputs: Svc_Retainer_Execute_Output7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monatliches Änderungsprotokoll`)
};

const es_svc_retainer_execute_output7 = /** @type {(inputs: Svc_Retainer_Execute_Output7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registro mensual de cambios`)
};

const fr_svc_retainer_execute_output7 = /** @type {(inputs: Svc_Retainer_Execute_Output7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Journal mensuel des changements`)
};

const pt_svc_retainer_execute_output7 = /** @type {(inputs: Svc_Retainer_Execute_Output7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registo mensal de mudanças`)
};

const zh_svc_retainer_execute_output7 = /** @type {(inputs: Svc_Retainer_Execute_Output7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`月度更新日志`)
};

const tr_svc_retainer_execute_output7 = /** @type {(inputs: Svc_Retainer_Execute_Output7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aylık değişiklik günlüğü`)
};

const ru_svc_retainer_execute_output7 = /** @type {(inputs: Svc_Retainer_Execute_Output7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Месячный ченджлог`)
};

const pl_svc_retainer_execute_output7 = /** @type {(inputs: Svc_Retainer_Execute_Output7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Miesięczny changelog`)
};

/**
* | output |
* | --- |
* | "Monthly changelog" |
*
* @param {Svc_Retainer_Execute_Output7Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_retainer_execute_output7 = /** @type {((inputs?: Svc_Retainer_Execute_Output7Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Retainer_Execute_Output7Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_retainer_execute_output7(inputs)
	if (locale === "bn") return bn_svc_retainer_execute_output7(inputs)
	if (locale === "de") return de_svc_retainer_execute_output7(inputs)
	if (locale === "es") return es_svc_retainer_execute_output7(inputs)
	if (locale === "fr") return fr_svc_retainer_execute_output7(inputs)
	if (locale === "pt") return pt_svc_retainer_execute_output7(inputs)
	if (locale === "zh") return zh_svc_retainer_execute_output7(inputs)
	if (locale === "tr") return tr_svc_retainer_execute_output7(inputs)
	if (locale === "ru") return ru_svc_retainer_execute_output7(inputs)
	if (locale === "pl") return pl_svc_retainer_execute_output7(inputs)
	return en_svc_retainer_execute_output7(inputs)
});
export { svc_retainer_execute_output7 as "svc_retainer_EXECUTE_output" }